import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-806e50e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "worp" }, [
  /*#__PURE__*/_createElementVNode("div", null, "开启功能后，将强制微信登录观看。微信登录功能不能与身份赋予、钉钉登录等功能同时使用。")
], -1))
const _hoisted_2 = { class: "worp_swt" }

import { message, Switch } from 'ant-design-vue';
// import store from '@/store';
import { computed } from 'vue';
import { useStore } from 'vuex';

const __default__ = { name: 'WeChatLogin' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const aSwitch = Switch;
// const checked = ref<boolean>(false);
const store = useStore();
const form = computed(() => store.state.authorizView.weView);
const checkWeSwitch = computed(() => store.state.authorizView.payView.paySwitch || store.state.authorizView.idView.idGiveSwitch);
const updateForm = () => {
  // console.log(form.value.wechatSwitch);
  message.destroy();
  if (form.value.wechatSwitch) {
    store.commit('authorizView/updateChildSwitch');
    store.commit('authorizView/checkWSwitch');
  }
  store.commit('authorizView/updateWeForm', form.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" 功能开关： "),
      _createVNode(_unref(aSwitch), {
        checked: _unref(form).wechatSwitch,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).wechatSwitch) = $event)),
        onChange: updateForm,
        disabled: _unref(checkWeSwitch)
      }, null, 8, ["checked", "disabled"])
    ])
  ], 64))
}
}

})